import { Col, Modal, Radio, Row } from "antd";
import React, { useEffect, useState } from "react";
import "../../../../assets/style/modalStyle/addAccount.scss";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { dealSelector } from "../../../../services/selector/index.";
import {
  createGroupTime,
  resetError,
  setOpenModalAddGroupTime,
} from "../../../../services/slice/DealSlice";

import BaseButton from "../../Button/BaseButton";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";
import { InputCode } from "../../Input/InputAddCodeGroup";
import { InputExcelUpload } from "../../Input/InputUploadExcel";

const ModalAddGroupTime = ({ type }) => {
  const { t } = useTranslation();
  const dealState = useSelector(dealSelector);
  const [msgErr, setMsgErr] = useState("");
  const [dataAdd, setDataAdd] = useState({
    name: "",
    beginNumber: type === 2 ? 0 : "",
    finishNumber: 0,
    typeGroup: type,
    optionType: 1,
  });

  const dispatch = useDispatch();
  const handleCancel = () => {
    dispatch(resetError());
    dispatch(setOpenModalAddGroupTime(false));
  };

  useEffect(() => {
    if (dealState.isError) {
      setMsgErr(dealState.msg);
    }
  }, [dealState.isError, dispatch]);

  const handleSave = () => {
    setMsgErr("");
    if (!dataAdd.name) {
      setMsgErr("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    dispatch(createGroupTime(dataAdd));
  };

  return (
    <>
      <Modal
        maskClosable={false}
        title={t(
          `Thêm nhóm ${
            type === 1
              ? "Đã sử dụng"
              : type === 2
              ? "Còn hạn"
              : type === 3
              ? "Hết hạn"
              : "Số máy KH sử dụng"
          }`
        )}
        centered
        open={dealState.isOpenModalAddGroupTime}
        className="warrperModalAddAcc"
        width={645}
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={155}
              content={"Lưu"}
              typeBtn="btnOrange"
              handleClick={handleSave}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Row align={"middle"} style={{ marginBottom: "1.5rem" }}>
          <Col span={8}>
            <LabelInput text={"Tên nhóm"} />
          </Col>
          <Col span={16}>
            <InputText
              focus
              maxLength={256}
              setText={(value) => setDataAdd({ ...dataAdd, name: value })}
              typeInput={
                msgErr === "Vui lòng nhập đầy đủ thông tin" && !dataAdd.name
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }
              placeholder={"Nhập tên nhóm"}
            />
          </Col>
        </Row>
       
        {(dataAdd.typeGroup === 1 || dataAdd.typeGroup === 3) && (
          <Row align={"middle"}>
            <Col span={8}>
              {dataAdd.typeGroup === 1 ? (
                <LabelInput text="Thời gian sử dụng từ" />
              ) : (
                <LabelInput text="Thời gian hết hạn từ" />
              )}
            </Col>
            <Col span={7}>
              <InputText
                placeholder="Nhập số"
                setText={(value) =>
                  setDataAdd({ ...dataAdd, beginNumber: value })
                }
              />
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>
              <LabelInput text="đến" />
            </Col>
            <Col span={7}>
              <InputText
                placeholder="Nhập số"
                setText={(value) =>
                  setDataAdd({ ...dataAdd, finishNumber: value })
                }
              />
            </Col>
          </Row>
        )}

        {dataAdd.typeGroup === 2 && (
          <Row align={"middle"}>
            <Col span={8}>
              <LabelInput text="Thời hạn còn lại dưới" />
            </Col>
            <Col span={16}>
              <InputText
                placeholder="Nhập số ngày"
                suffix="ngày"
                setText={(value) =>
                  setDataAdd({ ...dataAdd, finishNumber: value })
                }
              />
            </Col>
          </Row>
        )}

        {dataAdd.typeGroup === 4 && (
          <>
            <Row align={"middle"} style={{ marginBottom: 15 }}>
              <Col span={8}>
                <LabelInput text="Loại" />
              </Col>
              <Col span={16}>
                <Radio.Group
                  name="radiogroup"
                  value={dataAdd.optionType}
                  onChange={(e) =>
                    setDataAdd({ ...dataAdd, optionType: e.target.value })
                  }
                >
                  <Radio value={1}>Chính xác</Radio>
                  <Radio value={2}>Nằm trong khoảng</Radio>
                  <Radio value={3}>Lớn hơn</Radio>
                </Radio.Group>
              </Col>
            </Row>

            {dataAdd.optionType === 1 && (
              <Row align={"middle"}>
                <Col span={8}>
                  <LabelInput text="Số máy chính xác" />
                </Col>
                <Col span={16}>
                  <InputText
                    placeholder="Nhập số máy"
                    setText={(value) =>
                      setDataAdd({
                        ...dataAdd,
                        beginNumber: value,
                        finishNumber: 0,
                      })
                    }
                  />
                </Col>
              </Row>
            )}

            {dataAdd.optionType === 2 && (
              <Row align={"middle"}>
                <Col span={8}>
                  <LabelInput text="Số máy từ" />
                </Col>
                <Col span={7}>
                  <InputText
                    placeholder="Nhập số"
                    setText={(value) =>
                      setDataAdd({ ...dataAdd, beginNumber: value })
                    }
                  />
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <LabelInput text="đến" />
                </Col>
                <Col span={7}>
                  <InputText
                    placeholder="Nhập số"
                    setText={(value) =>
                      setDataAdd({ ...dataAdd, finishNumber: value })
                    }
                  />
                </Col>
              </Row>
            )}

            {dataAdd.optionType === 3 && (
              <Row align={"middle"}>
                <Col span={8}>
                  <LabelInput text="Số máy lớn hơn" />
                </Col>
                <Col span={16}>
                  <InputText
                    placeholder="Nhập số máy"
                    setText={(value) =>
                      setDataAdd({
                        ...dataAdd,
                        beginNumber: 0,
                        finishNumber: value,
                      })
                    }
                  />
                </Col>
              </Row>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default ModalAddGroupTime;
